// import addTrainQy from '../components/trainQy/addTrainQy.vue'
// import editTrainQy from '../components/trainQy/editTrainQy.vue'
// import trainQyList from '../components/trainQy/trainQyList.vue'

export default [
    {
        path: 'trainQy/addTrainQy',
        component: resolve => require(['@/components/trainQy/addTrainQy'],resolve),
        name:"AddTrainQy",
        meta:{
            id:'716',
            node:'trainQy',
            url:'addTrainQy',
        }
    },
    {
        path: 'trainQy/editTrainQy',
        component: resolve => require(['@/components/trainQy/editTrainQy'],resolve),
        name:"EditTrainQy",
        meta:{
            id:'717',
            node:'trainQy',
            url:'editTrainQy',
        }
    },
    {
        path: 'trainQy/trainQyList',
        component: resolve => require(['@/components/trainQy/trainQyList'],resolve),
        name:"TrainQyList",
        meta:{
            id:'715',
            node:'trainQy',
            url:'trainQyList',
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/trainQy.js